export default function SiteFooter() {
  const cols = [
    { title: "91cg热榜", links: ["实时热榜", "热议排行榜", "板块速递", "追更广场"] },
    { title: "围观玩法", links: ["发布瓜点", "群众围观", "神评图鉴", "热词趋势"] },
    { title: "关于我们", links: ["站点介绍", "收录规则", "合作联系", "问题反馈"] },
  ];

  return (
    <footer className="w-full border-t border-background-200/80 bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* brand */}
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2 cursor-pointer">
              <span className="font-display text-3xl md:text-4xl leading-none text-primary-500">91cg</span>
              <span className="flex flex-col leading-tight pl-3 border-l border-background-300">
                <span className="text-sm font-bold text-foreground-900">91cg热榜</span>
                <span className="text-xs text-foreground-500">热门吃瓜排行榜</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              91cg 帮你把关注度高的内容顺位摆出来，大家正在看的、正在讨论的都在排行里，按榜点开即可快速跟上热门吃瓜节奏。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-douban-line", "ri-bilibili-line"].map((ic, i) => (
                <a
                  key={i}
                  href="#top"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-200 text-foreground-500 hover:text-primary-600 hover:border-primary-300 transition-colors cursor-pointer"
                  aria-label="social"
                >
                  <i className={`${ic} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* link cols */}
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-foreground-900">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-foreground-500 hover:text-primary-600 cursor-pointer">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/70 pt-6">
          <p className="text-xs text-foreground-400 text-center sm:text-left">
            91cg | 91cg热榜、91cg排行榜，看91cg热门吃瓜 · 仅供演示
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#top" className="hover:text-primary-600 cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#top" className="hover:text-primary-600 cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#top" className="hover:text-primary-600 cursor-pointer whitespace-nowrap">帮助中心</a>
          </div>
        </div>
      </div>
    </footer>
  );
}